import { useTranslation } from "react-i18next";

import type { Supplier } from "@/apis/gql/types";
import FiltersRoot, {
  SupplierFilter,
} from "@/components/shared/data-table/filters";
import { Skeleton } from "@/components/ui/skeleton";
import type { InvoiceTypeString } from "@/lib/constants/invoice-type";

type Props = {
  config: any;
  loading: boolean;
  values: {
    supplierId: string;
  };
  onSupplierChange: (supplierId: string, origin: string) => void;
  invoiceType?: InvoiceTypeString;
};

export const Filters = ({
  config,
  values,
  onSupplierChange,
  loading,
  invoiceType,
}: Props) => {
  const { t } = useTranslation();

  const handleSubmit = (data: { supplierId: string }) => {
    const { supplierId } = data;

    const suppliersWithUnknowns = config.suppliers.map((s: Supplier) => {
      if (s.supplierId === null) {
        return {
          ...s,
          supplierId: "unknown",
        };
      }
      return s;
    });

    if (
      !suppliersWithUnknowns.some((s: Supplier) => s.supplierId === supplierId)
    ) {
      return;
    }

    onSupplierChange(supplierId, "filter");
  };

  return (
    <div>
      <FiltersRoot onSubmit={handleSubmit} values={values}>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium whitespace-nowrap">
            {invoiceType === "receivable"
              ? t("debtors.title")
              : t("creditors.title")}
            :
          </span>
          {loading && !values.supplierId ? (
            <Skeleton className="h-11 w-96" />
          ) : (
            <div className="w-96">
              <SupplierFilter
                options={config.suppliers ?? []}
                placeholder={
                  invoiceType === "receivable"
                    ? t("debtors.title")
                    : t("creditors.title")
                }
                createSupplier={false}
                type={invoiceType === "receivable" ? "debtor" : "creditor"}
              />
            </div>
          )}
        </div>
      </FiltersRoot>
    </div>
  );
};
